"use strict";

/**
 * DGF-3054 — PDP express wallets, loaded from Superdry's existing productDetail.js bundle.
 *
 * Lives one directory down on purpose: webpack globs entries one JS level only
 * (webpack.config.js:51), so this file is bundled into productDetail.js rather than becoming a
 * separate entry. It is the only PDP file that resolves the vendor cartridge, through the
 * `adyenSFRA` alias; the behaviour is in ../adyen/express/productWallets, which takes its
 * dependencies as arguments.
 *
 * Loading it unconditionally is safe and costs nothing when express is off: with PDP express
 * disabled the server renders no express markup at all, so init() finds no container, makes no
 * request and mounts nothing.
 */

const ApplePay = require("adyenSFRA/adyen/express/paymentMethods/applepay/applepay");
const GooglePay = require("adyenSFRA/adyen/express/paymentMethods/googlepay/googlepay");
// DGF-4617 — the DIRECT PayPal express wallet (int_paypal), a local wallet rendered through the
// same pipeline. Self-contained: it talks to the Paypal-* routes and PayPal's own SDK.
const paypalExpressWallet = require("../adyen/express/paypalExpressWallet");
const { getExpressPaymentMethods, calculateProductPrice } = require("adyenSFRA/adyen/commons/index");
// The shared helpers module object, wrapped at runtime so the express confirmation form carries a
// CSRF token. Already in the bundle — both wallet classes require it.
const adyenHelpers = require("adyenSFRA/adyen/checkout/helpers");
const productWallets = require("../adyen/express/productWallets");

/**
 * The copy shown when the wallets cannot be started at all, read off the PDP express row's
 * data-express-error-message attribute (product/components/addToCartButtonExtension.isml).
 *
 * Client JS cannot call Resource.msg, and this string cannot come through window: ISML HTML-encodes
 * ${} inside a <script> as well, so the French translation would reach the shopper as "n&#39;avons".
 * getAttribute decodes, so the attribute is the one context where the default encoding is correct.
 *
 * Unlike the bag, this one is genuinely visible: productWallets.js:506 shows the message WITHOUT
 * calling setSurfaceVisibility(false) afterwards, so the section is still on the page. That is the
 * failure the resourced string was written for — a /paymentMethods fetch that throws used to leave
 * an empty box under the add-to-bag button with nothing said.
 *
 * @param {Object} doc - the document
 * @returns {string} the resourced message, or "" when the attribute is not present
 */
function readErrorMessage(doc) {
    const holder = doc && typeof doc.querySelector === "function"
        ? doc.querySelector("[data-express-error-message]")
        : null;
    return (holder && holder.getAttribute("data-express-error-message")) || "";
}

module.exports = function initProductExpressPayments() {
    productWallets.init({
        $: $,
        win: window,
        doc: document,
        nav: window.navigator,
        ApplePay: ApplePay,
        GooglePay: GooglePay,
        walletClasses: { applepay: ApplePay, googlepay: GooglePay },
        localWallets: { paypal: paypalExpressWallet },
        helpers: adyenHelpers,
        getExpressPaymentMethods: getExpressPaymentMethods,
        calculateProductPrice: calculateProductPrice,
        errorMessage: readErrorMessage(document)
    });
};
